import { render, staticRenderFns } from "./EditSoundDlg.vue?vue&type=template&id=76127104"
import script from "./EditSoundDlg.vue?vue&type=script&lang=ts"
export * from "./EditSoundDlg.vue?vue&type=script&lang=ts"
import style0 from "./EditSoundDlg.vue?vue&type=style&index=0&id=76127104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports